import { Link } from 'react-router-dom';
import { useInviteGate } from '../../context/InviteGateContext';

// UX review: footer text on #2C2C2C meets WCAG AA (4.5:1). Ratios: links/tagline #BDBDBD 7.43:1,
// column headings and bottom bar #AAAAAA 6.01:1, trust chips #C8C8C8 on #393939 6.90:1
// (previously #777 3.12:1, #666 2.43:1, #555 1.87:1, #888 on chip 3.26:1).
const PUBLIC_LINKS = [['Terms', '/terms'], ['Privacy', '/privacy'], ['Refunds', '/refunds']];

export default function Footer() {
  // While the invite gate locks the visitor out, marketplace pages only lead to InviteSplash, so the
  // footer keeps just the pages that stay public (/terms, /privacy, /refunds).
  const { locked: gateLocked } = useInviteGate();
  const cols = [
    { title: 'Explore',  links: [['Browse All', '/browse'], ['Rentals', '/browse?type=rent'], ['Auctions', '/browse?type=auction'], ['For Sale', '/browse?type=sale'], ['Categories', '/categories']] },
    { title: 'Sellers',  links: [['List an item', '/list'], ['How it Works', '/how-it-works'], ['Pricing & fees', '/fees'], ['Seller guide', '/seller-guide'], ['Payouts', '/dashboard/payouts']] },
    { title: 'Company',  links: [['About us', '/about'], ['Trust & Safety', '/trust'], ['Help centre', '/help'], ['Terms of service', '/terms'], ['Privacy policy', '/privacy']] },
  ];

  return (
    <footer className="site-footer">
      <style>{`
        .site-footer { background: #2C2C2C; padding: 48px 48px 24px; }
        .footer-grid { display: grid; grid-template-columns: 2fr 1fr 1fr 1fr; gap: 52px; padding-bottom: 32px; border-bottom: 1px solid #3a3a3a; margin-bottom: 24px; }
        .footer-bottom { display: flex; align-items: center; justify-content: space-between; font-size: 12px; color: #AAAAAA; flex-wrap: wrap; gap: 10px; }
        .footer-link { font-size: 13px; color: #BDBDBD; text-decoration: none; transition: color .2s; }
        .footer-link:hover, .footer-link:focus-visible { color: white; }
        .footer-bottom-link { color: #BDBDBD; text-decoration: none; transition: color .2s; }
        .footer-bottom-link:hover, .footer-bottom-link:focus-visible { color: white; }
        @media (max-width: 768px) {
          .site-footer { padding: 32px 20px 16px; }
          .footer-grid { grid-template-columns: 1fr 1fr; gap: 28px; }
        }
      `}</style>
      <div className="container" style={{ maxWidth: 1280 }}>
        <div className="footer-grid" style={gateLocked ? { gridTemplateColumns: '1fr' } : undefined}>
          <div>
            <Link to="/" className="tap-target" style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 12, textDecoration:'none' }}>
              <span style={{ fontSize: 22 }}>🍒</span>
              <span style={{ fontFamily: "'Playfair Display',serif", fontWeight: 700, fontSize: 20 }}>
                <span style={{ color: '#C0392B' }}>cherry</span><span style={{ color: 'white' }}>pkd</span>
              </span>
            </Link>
            <p style={{ fontSize: 13, color: '#BDBDBD', lineHeight: 1.7, maxWidth: gateLocked ? 420 : 240, marginBottom: 16 }}>
              Rent it. Bid on it. Buy it. The marketplace built on trust, powered by community.
              {gateLocked && ' Browsing is invite-only during the soft launch.'}
            </p>
            <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
              {['🔒 Payments by Stripe', '🛡️ Funds held until the order is confirmed'].map(b => (
                <div key={b} style={{ padding: '4px 9px', background: 'rgba(255,255,255,.06)', borderRadius: 6, fontSize: 11, fontWeight: 600, color: '#C8C8C8' }}>{b}</div>
              ))}
            </div>
          </div>
          {!gateLocked && cols.map(col => (
            <div key={col.title}>
              <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: '2.5px', textTransform: 'uppercase', color: '#AAAAAA', marginBottom: 14 }}>{col.title}</div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 9 }}>
                {col.links.map(([label, path]) => (
                  <Link key={path} to={path} className="footer-link">{label}</Link>
                ))}
              </div>
            </div>
          ))}
        </div>
        <div className="footer-bottom">
          <span>© 2026 CherryPKD. All rights reserved.</span>
          <div style={{ display: 'flex', gap: 20 }}>
            {(gateLocked ? PUBLIC_LINKS : [['Privacy', '/privacy'], ['Terms', '/terms'], ['Cookies', '/cookies'], ['Sitemap', '/sitemap']]).map(([l, p]) => (
              <Link key={p} to={p} className="footer-bottom-link">{l}</Link>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
